window.addEventListener('DOMContentLoaded', () =>
{
  const form = document.querySelector('.subscriprion__form');
  const successModal = document.querySelector('.form-success');
  const closeSuccess = document.querySelector('.form-success__close');


  if(form)
  {
    form.onsubmit = (e) =>
    {
      e.preventDefault();
      fetch('/local/api/blog/subscribe.php', {
        method: 'POST',
        body: new FormData(form),
      })
          .then((response) => response.json())
          .then(function(response)
          {
            if(response.status === 'ok')
            {
              successModal.classList.remove('visually-hidden');
              form.reset();
            }
            else if(response.status === 'subscribed')
            {
              alert('На данную почту уже оформлена подписка');
            }
            else
            {
              alert('Error');
            }
          })
          .catch((error) => alert('Error:', error));
    };
  }

  const closeModal = () =>
  {
    successModal.classList.add('visually-hidden');
  };

  closeSuccess.addEventListener('click', closeModal);
});

// /local/templates/program-picker/ajax/programfeedback.php
